import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, Icon, Label, Dropdown, Input, Button } from 'semantic-ui-react'

import "semantic-ui-css/components/label.min.css";
import "semantic-ui-css/components/card.min.css";
import "semantic-ui-css/components/icon.min.css";
import './AdminSettings.css';

const roleOptions = [
  {key: '', value: '', text: "Select Smthin"},
  {key: 'SU', value: 'SU', text: "Make him/her a God"},
  {key: 'DNS_MANAGER', value: 'DNS_MANAGER', text: "DNS Manager"},
  {key: 'MGMT', value: 'MGMT', text: "Managment"},
  {key: 'BD', value: 'BD', text: "Business Dev."},
  {key: 'CC_LEVEL_1', value: 'CC_LEVEL_1', text: "Customer Care Agent"},
  {key: 'TECH', value: 'TECH', text: "Tech"},
  {key: 'CC_APPROVER', value: 'CC_APPROVER', text: "Refund Approver"},
  {key: 'CC_MANAGER', value: 'CC_MANAGER', text: "Refund Manager"},
  {key: 'OPT', value: 'OPT', text: "Optimization"},
  {key: 'CC_LEVEL_1_US', value: 'CC_LEVEL_1_US', text: "Customer Care Agent ('Murica)"},
  {key: 'CC_LEVEL_1_AE', value: 'CC_LEVEL_1_AE', text: "Customer Care Agent (Dubai)"},
  {key: 'CC_APPROVER_US', value: 'CC_APPROVER_US', text: "Refund Approver ('Murica)"},
  {key: 'CC_APPROVER_AE', value: 'CC_APPROVER_AE', text: "Refund Approver (Dubai)"},
  {key: 'CC_MANAGER_AE', value: 'CC_MANAGER_AE', text: "Refund Manager (Dubai)"},
  {key: 'CC_MANAGER_US', value: 'CC_MANAGER_US', text: "Refund Manager ('Murica)"}
  
]

export default class AdminSettingsRoute extends Component {
  static propTypes = {
    users: PropTypes.array,
    getUsers: PropTypes.func,
    loading: PropTypes.bool,
    addUserRole: PropTypes.func,
    deleteUserRole: PropTypes.func,
    logoutUser: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.props.getUsers()
    this.state = {
      search: ''
    }
  }

  search = (e, { value }) => this.setState({ search: value })

  render() {
    return (
      <div className="AdminSettingsRoute">
        <h3>Admin Settings</h3>
        <Input className="Search" placeholder='Search...' value={this.state.search} onChange={this.search} />
        <Card.Group
          loading={this.props.loading}
          items={this.props.users ? this.props.users.filter(user => user.email.includes(this.state.search)).map(user => ({
            header: <div className='custom-header' dangerouslySetInnerHTML={{ __html: user.email.replace(this.state.search, `<b>${this.state.search}</b>`) }} />,
            meta: user.online ? 'online' : 'offline',
            description: <div>
              {user.online ? <Button style={{ width: '100%'}} compact onClick={() => this.props.logoutUser(user._id)}>Logout User</Button> : null}
              {user.roles.map(role => <Label as='a'>{role} <Icon name="delete" onClick={() => this.props.deleteUserRole(user._id, role)}/></Label>)}
              <Dropdown
                placeholder='Select Role To Add'
                fluid
                search
                selection
                value=''
                onChange={(e, { value }) => value ? this.props.addUserRole(user._id, value) : null}
                options={roleOptions}
              />
            </div>
          })) : []}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminSettingsRouteComponent/AdminSettings.js